<template>
  <div id="content">
    <div class="banner">
      <AboutSwiperComponent></AboutSwiperComponent>
    </div>
    <div class="about_block">
      <div class="about_title"><h2>关于我们</h2></div>
      <div class="about_text">广州市台资企业协会成立于1994年，致力于为在穗台商台胞为广州经济社会发展、穗台融合发展做出最大的贡献，持续推动穗台应通尽通、融合发展，穗台经贸合作水平稳步提升。发挥“领头羊”作用，当好两岸关系和平发展、穗台融合发展的示范者、领跑者、推动者、实践者，团结和带领更多爱国台胞，共担民族大义、共赴民族复兴，做堂堂正正的中国人!</div>
    </div>
    <!-- 协会资讯、办事指南、政策法规 -->
    <div id="xbz">
      <div class="xbz_zx">
        <img src="../assets/image1.png" alt="" class="arrow">
        <h2 class="title">协会资讯</h2>
        <h3 class="sub_title">白云分会召开换届筹备会</h3>
        <p class="time">2024-06-12</p>
      </div>
      <div class="xbz_zn">
        <img src="../assets/image1.png" alt="" class="arrow">
        <h2 class="title">办事指南</h2>
        <h3 class="sub_title">一则办事指南标题</h3>
        <p class="time">2024-06-12</p>
      </div>
      <div class="xbz_fg">
        <img src="../assets/image1.png" alt="" class="arrow">
        <h2 class="title">政策法规</h2>
        <h3 class="sub_title">购房、买车、就医、找工作...</h3>
        <p class="time">2024-06-12</p>
      </div>
    </div>

    <!-- 加入会员 -->
    <div class="join_member_container">
      <JoinMemberComponent></JoinMemberComponent>
    </div>

    <!-- 底部链接 -->
    <FooterComponent></FooterComponent>
    <!-- 版权 -->
    <CopyrightLayout></CopyrightLayout>
    <div style="clear:both"></div>
  </div>
</template>


<script>
import AboutSwiperComponent from "@/components/AboutSwiperComponent.vue";
import JoinMemberComponent from "@/components/JoinMemberComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import CopyrightLayout from "@/layout/CopyrightLayout.vue";
export default {
  name: "AboutPage",
  components: { AboutSwiperComponent,JoinMemberComponent,FooterComponent,CopyrightLayout },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped>
@import "../style/common.css";
@import "../style/about.css";
</style>